var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPictures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 89.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#ff4500;stroke-miterlimit:10;stroke-width:1.51px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23.57 43.62 23.57 19.85 79.75 19.85 79.75 64.66 40.94 64.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "25.5 44.47 35.77 32.76 66.6 64.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "56.07 49.39 67.5 37.09 80.13 50.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.67,43.62V20.77a5.64,5.64,0,0,1,5.63-5.64H80a5.65,5.65,0,0,1,5.64,5.64V73.5A5.64,5.64,0,0,1,80,79.14H31.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,13.53A5.64,5.64,0,0,1,30.65,7.9H87.37A5.63,5.63,0,0,1,93,13.53V66.27a5.63,5.63,0,0,1-5.63,5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.25,6.39A5.63,5.63,0,0,1,37.89.76H94.61a5.63,5.63,0,0,1,5.63,5.63V59.13a5.63,5.63,0,0,1-5.63,5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.11,37.28a10.67,10.67,0,0,1,14.74-2.22,10.69,10.69,0,0,1,3.08,3.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.4,67.29l-17.88-22a2.41,2.41,0,0,0-3.76,0l-17.48,22a2.42,2.42,0,0,0,1.9,3.91H12V88.74H29.77V71.22h8.75A2.41,2.41,0,0,0,40.4,67.29Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPictures);
export default __webpack_public_path__ + "static/media/icon-pictures.301920af307c01fad4c78ca68bbb2b31.svg";
export { ForwardRef as ReactComponent };